<template>
    <div class="pa-4">
        <v-row>
            <v-col cols="12" md="6">
            <div>
                <v-card elevation="0" class="mb-6">
                    <v-card-title class="d-flex justify-space-between">
                        <h1 class="font-weight-thin primary--text">Group Management</h1>
                        <v-icon color="primary" x-large>mdi-select-group</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <GroupsSummary/>
                    </v-card-text>
                </v-card>
                <v-card elevation="0">
                    <v-card-title class="d-flex justify-space-between">
                        <h1 class="font-weight-thin primary--text">Tenant-Group Management</h1>
                        <v-icon color="primary" x-large>mdi-lock-plus</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <TenantGroupsSummary/>
                    </v-card-text>
                </v-card>
            </div>
            </v-col>
            <v-col cols="12" md="6">
                <v-card elevation="0">
                    <v-card-title class="d-flex justify-space-between">
                        <h1 class="font-weight-thin primary--text">Permission Management</h1>
                        <v-icon color="primary" x-large>mdi-key-variant</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <PermissionsSummary/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import GroupsSummary from '@/components/DatabaseManagement/Auth/Groups/GroupsSummary.vue';
import TenantGroupsSummary from '@/components/DatabaseManagement/Auth/TenantGroups/TenantGroupsSummary.vue';
import PermissionsSummary from '@/components/DatabaseManagement/Auth/Permissions/PermissionsSummary.vue';


export default {
    name: 'AuthBase',
    components: {
        GroupsSummary,
        PermissionsSummary,
        TenantGroupsSummary
    },
};
</script>